import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/authService';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Double-check localStorage as fallback (in case state hasn't updated yet)
  const hasStoredAuth = authService.isAuthenticated();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check both state and localStorage
  if (!isAuthenticated && !hasStoredAuth) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
